/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GenerateObjectsPresignedUrlsResponse } from '../models/generate-objects-presigned-urls-response';
import { presignedUrlForDownload } from '../fn/presigned-url-controller/presigned-url-for-download';
import { PresignedUrlForDownload$Params } from '../fn/presigned-url-controller/presigned-url-for-download';
import { presignedUrlForUpload } from '../fn/presigned-url-controller/presigned-url-for-upload';
import { PresignedUrlForUpload$Params } from '../fn/presigned-url-controller/presigned-url-for-upload';
import { UploadPresignedUrlResponse } from '../models/upload-presigned-url-response';

@Injectable({ providedIn: 'root' })
export class PresignedUrlControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `presignedUrlForUpload()` */
  static readonly PresignedUrlForUploadPath = '/v1/presigned/upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `presignedUrlForUpload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  presignedUrlForUpload$Response(
    params: PresignedUrlForUpload$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<UploadPresignedUrlResponse>> {
    return presignedUrlForUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `presignedUrlForUpload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  presignedUrlForUpload(
    params: PresignedUrlForUpload$Params,
    context?: HttpContext
  ): Observable<UploadPresignedUrlResponse> {
    return this.presignedUrlForUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadPresignedUrlResponse>): UploadPresignedUrlResponse => r.body)
    );
  }

  /** Path part for operation `presignedUrlForDownload()` */
  static readonly PresignedUrlForDownloadPath = '/v1/presigned/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `presignedUrlForDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  presignedUrlForDownload$Response(
    params: PresignedUrlForDownload$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenerateObjectsPresignedUrlsResponse>> {
    return presignedUrlForDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `presignedUrlForDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  presignedUrlForDownload(
    params: PresignedUrlForDownload$Params,
    context?: HttpContext
  ): Observable<GenerateObjectsPresignedUrlsResponse> {
    return this.presignedUrlForDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenerateObjectsPresignedUrlsResponse>): GenerateObjectsPresignedUrlsResponse => r.body)
    );
  }
}
